import * as Blockly from "blockly/core";
import * as BlockDynamicConnection from "@blockly/block-dynamic-connection";

//General options of workspace (toolbox is generated dynamicly depending on G)
export var optionsWorkspace = {
  /*
  plugins: {
    connectionPreviewer: BlockDynamicConnection.decoratePreviewer(
      // Replace with a custom connection previewer, or remove to decorate
      // the default one.
      Blockly.InsertionMarkerPreviewer
    ),
  },
  */
  collapse: true,
  renderer: "thrasos", // defines blocks style // PRO
  //renderer: "zelos", // defines blocks style // BEGINNER
  //renderer: "geras", // defines blocks style // TEST

  comments: true,
  disable: false,
  maxBlocks: Infinity,
  trashcan: true,
  horizontalLayout: false,
  toolboxPosition: "start",
  css: true,
  media: "/media/",
  rtl: false,
  scrollbars: true,
  sounds: true,
  oneBasedIndex: true,
  grid: {
    spacing: 20,
    length: 1,
    colour: "#888",
    snap: false,
  },
  zoom: {
    controls: true,
    wheel: false,
    startScale: 1,
    maxScale: 3,
    minScale: 0.1,
    scaleSpeed: 1.07,
    pinch: true, //for tablets
  },
  move: {
    scrollbars: {
      horizontal: true,
      vertical: true,
    },
    drag: true,
    wheel: true,
  },
};

//SET GENERAL SATURATION
Blockly.utils.colour.setHsvSaturation(0.65); // 0 (inclusive) to 1 (exclusive), defaulting to 0.45
//Blockly.HSV_SATURATION = 0.65;
Blockly.utils.colour.setHsvValue(0.7); // 0 (inclusive) to 1 (exclusive), defaulting to 0.65
//Blockly.HSV_VALUE = 0.7;

//Categories' and their Blocks' Color
// For std Blockly Blocks and std Categories we use theme properties with blockStyles and categoryStyles
// For Eleda Block we use global var (called from toolbox.xml) Blockly.Msg['xxx']

var colorStart = 100;
var colorStep = 18;
var color = colorStart;
//init object of theme with whyte (to identify which fails if any)
export const blockStyles = {
  variable_blocks: {
    colourPrimary: "#fff",
  },
  list_blocks: {
    colourPrimary: "#fff",
  },
  matrix_blocks: {
    colourPrimary: "#fff",
  },
  stats_blocks: { colourPrimary: "#fff" },
  text_blocks: {
    colourPrimary: "#fff",
  },
  math_blocks: {
    colourPrimary: "#fff",
  },
  lang_blocks: {
    colourPrimary: "#fff",
  },
  logic_blocks: {
    colourPrimary: "#fff",
  },
  loop_blocks: {
    colourPrimary: "#fff",
  },
  /*colour_blocks: {
    colourPrimary: "#fff",
  },*/
  procedure_blocks: {
    colourPrimary: "#fff",
  } /*
  variable_dynamic_blocks: {
    colourPrimary: "#fff",
  },*/,
};
//init object of theme with white (to identify which fails if any)
export const categoryStyles = {
  variable_category: {
    colour: "#fff",
  },
  list_category: {
    colour: "#fff",
  },
  matrix_category: {
    colour: "#fff",
  },
  stats_category: {
    colour: "#fff",
  },
  text_category: {
    colour: "#fff",
  },
  math_category: {
    colour: "#fff",
  },
  lang_category: {
    colour: "#fff",
  },
  logic_category: {
    colour: "#fff",
  },
  loop_category: {
    colour: "#fff",
  },
  /* colour_category: {
    colour: "#fff",
  },*/
  procedure_category: {
    colour: "#fff",
  } /*
  variable_dynamic_category: {
    colourPrimary: "#fff",
  },*/,
};

//TWO CASES TO DEFINE COLOR CATEGORY AND BLOCKS
//1: it's a standard existing blockly cat and blocks : overide existing colors in the existing json
//2: it's a new Eleda category : create and define the color with json
Blockly.Msg["START_HUE"] = color;
categoryStyles.start_category = { colour: color };

color = (color + colorStep) % 360;
categoryStyles.display_category = { colour: color };
Blockly.Msg["DISPLAY_HUE"] = color;

color = (color + colorStep) % 360;
categoryStyles.question_category = { colour: color };
Blockly.Msg["QUESTION_HUE"] = color;

color = (color + colorStep) % 360;
categoryStyles.feedback_category = { colour: color };
Blockly.Msg["FEEDBACK_HUE"] = color;

//MEDIA
color = (color + colorStep) % 360;
categoryStyles.media_category = { colour: color };
Blockly.Msg["MEDIA_HUE"] = color;

//TEXT
color = (color + colorStep) % 360;
blockStyles.text_blocks.colourPrimary = color;
categoryStyles.text_category.colour = color;
Blockly.Msg["TEXT_HUE"] = color;
//LISTS
color = (color + colorStep) % 360;
blockStyles.list_blocks.colourPrimary = color;
categoryStyles.list_category.colour = color;
Blockly.Msg["LIST_HUE"] = color;
//MATH CATEGORY
//ALGEBRA
color = (color + colorStep) % 360;
categoryStyles.algebra_category = { colour: color };
Blockly.Msg["ALGEBRA_HUE"] = color;

//MATHCAT : color is defined in css
blockStyles.math_blocks.colourPrimary = color;
categoryStyles.math_category.colour = color;
Blockly.Msg["MATH_HUE"] = color;
//ANALYSIS
color = (color + colorStep) % 360;
categoryStyles.analysis_category = { colour: color };
Blockly.Msg["ANALYSIS_HUE"] = color;

//GEOMETRY
color = (color + colorStep) % 360;
categoryStyles.geometry_category = { colour: color };
Blockly.Msg["GEOMETRY_HUE"] = color;

//MATRIX
color = (color + colorStep) % 360;
blockStyles.matrix_blocks.colourPrimary = color;
categoryStyles.matrix_category.colour = color;
Blockly.Msg["MATRIX_HUE"] = color;

//STATS
color = (color + colorStep) % 360;
blockStyles.stats_blocks.colourPrimary = color;
categoryStyles.stats_category.colour = color;
Blockly.Msg["STATS_HUE"] = color;

//LANG CATEGORY
//FRENCH
color = (color + colorStep) % 360;
Blockly.Msg["FRENCH_HUE"] = color;
//LANGCAT : std lang blockly cat same colors as french
blockStyles.lang_blocks.colourPrimary = color;
categoryStyles.lang_category.colour = color;
Blockly.Msg["LANG_HUE"] = color;
//VARIABLES
color = (color + colorStep) % 360;
blockStyles.variable_blocks.colourPrimary = color;
categoryStyles.variable_category.colour = color;
Blockly.Msg["VARIABLE_HUE"] = color;
//LOGIC
color = (color + colorStep) % 360;
blockStyles.logic_blocks.colourPrimary = color;
categoryStyles.logic_category.colour = color;
Blockly.Msg["LOGIC_HUE"] = color;
//LOOP
color = (color + colorStep) % 360;
blockStyles.loop_blocks.colourPrimary = color;
categoryStyles.loop_category.colour = color;
Blockly.Msg["LOOP_HUE"] = color;
//COLOUR
/*color = (color + colorStep) % 360;
blockStyles.colour_blocks.colourPrimary = color;
categoryStyles.colour_category.colour = color;
Blockly.Msg["COLOR_HUE"] = color;*/
//PROCEDURES
color = (color + colorStep) % 360;
blockStyles.procedure_blocks.colourPrimary = color;
categoryStyles.procedure_category.colour = color;
Blockly.Msg["PROCEDURES_HUE"] = color;

//variable_dynamic
/*
color = (color + colorStep) % 360
blockStyles.variable_dynamic_blocks.colourPrimary = color
categoryStyles.variable_dynamic_category.colour = color
Blockly.Msg['VARIABLE_DYNAMIC_HUE'] = color
*/
export const themeWorkspace = Blockly.Theme.defineTheme("Eleda", {
  base: "classic",
  blockStyles: blockStyles,
  categoryStyles: categoryStyles,
  startHats: true,
  componentStyles: {
    workspaceBackgroundColour: "#ffffff",
    toolboxBackgroundColour: "#ffffff",
  },
});
